export function initCookieConsent() {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;

  const consent = localStorage.getItem('dcco-cookie-consent');
  if (consent) return;

  setTimeout(() => {
    banner.classList.remove('hidden');
  }, 1500);

  const acceptBtn = banner.querySelector('[data-cookie-accept]');
  const rejectBtn = banner.querySelector('[data-cookie-reject]');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      localStorage.setItem('dcco-cookie-consent', 'accepted');
      banner.classList.add('hidden');
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      localStorage.setItem('dcco-cookie-consent', 'rejected');
      banner.classList.add('hidden');
    });
  }
}
